import { PostHogProvider } from 'posthog-js/react';
import { FC } from 'react';

import { Environment } from '../../constants/environments';
import { I18nProvider } from '../../hooks/contexts/i18n.context';
import { LoaderScreenProvider } from '../../hooks/contexts/loader-screen.context';
import { ModalProvider } from '../../hooks/contexts/modal.context';
import { ThemeProvider } from '../../hooks/contexts/theme.context';
import { UserProvider } from '../../hooks/contexts/user.context';
import { MembershipProvider } from './membership.context';
import { SsoProvider } from './sso.context';

type Props = {
  children: React.ReactNode
}

const options = {
  api_host : Environment.PUBLIC_POSTHOG_HOST
};

const Providers: FC<Props> = ({ children }) => {

  return (
    <LoaderScreenProvider>
      <PostHogProvider
        apiKey={Environment.PUBLIC_POSTHOG_KEY || ''}
        options={options}
      >
        <I18nProvider>
          <UserProvider>
            <MembershipProvider>
              <ThemeProvider>
                <ModalProvider>
                  <SsoProvider>
                    {children}
                  </SsoProvider>
                </ModalProvider>
              </ThemeProvider>
            </MembershipProvider>
          </UserProvider>
        </I18nProvider>
      </PostHogProvider>
    </LoaderScreenProvider>
  );
};

export default Providers;

